//////////////////////////////////////////////////////////////////////
//
//  10/05/18
//  src/components/MapPage.js
//
//  This file is a single block of full data.
//

import React   from 'react';
import NameBlk from "./NameBlk";
import './MapPage.css';

const MapPage = ({ miles, name, row, music, food, happy, notes, mpop, fpop, hpop, addr }) => (
  <div className="MapPage">

    <div className="MapPageName">
      <NameBlk row={ row }     name={ name } miles={ miles } type={ "map" }
               music={ music } food={ food } happy={ happy } notes={ notes }
               mpop ={ mpop  } fpop={ fpop } hpop ={ hpop  } addr ={ addr  } />
    </div>

  </div>
);

export default MapPage;




// WEBPACK FOOTER //
// ./src/components/MapPage.js